(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fullscreen-background"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.mlfFullscreenHeroSoundToggleReady) return;
    window.mlfFullscreenHeroSoundToggleReady = true;

    const heroSelector = '[data-mlf-home-hero]';
    const videoSelector = '[data-mlf-hero-video]';
    const toggleSelector = '[data-mlf-hero-sound-toggle]';

    const isVisible = (element) => {
      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    };

    const getActiveMedia = (hero) => {
      const media = Array.from(hero.querySelectorAll(videoSelector));

      return media.find(isVisible) || null;
    };

    const setIframeSound = (iframe, enabled) => {
      const provider = iframe.dataset.mlfVideoProvider;

      if (!iframe.contentWindow || !provider) return;

      if (provider === 'youtube') {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: enabled ? 'unMute' : 'mute', args: [] }),
          '*'
        );

        if (enabled) {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
        }
      }

      if (provider === 'vimeo') {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: enabled ? 1 : 0 }), '*');

        if (enabled) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        }
      }
    };

    const setMediaSound = (media, enabled) => {
      if (media instanceof HTMLVideoElement) {
        media.muted = !enabled;
        media.volume = enabled ? 1 : 0;

        if (enabled) {
          media.removeAttribute('muted');
          media.play().catch(() => {});
        } else {
          media.setAttribute('muted', '');
        }

        return;
      }

      if (media instanceof HTMLIFrameElement) {
        setIframeSound(media, enabled);
      }
    };

    const startIframePlayback = (iframe) => {
      const provider = iframe.dataset.mlfVideoProvider;

      if (!iframe.contentWindow || !provider) return;

      if (provider === 'youtube') {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
      }

      if (provider === 'vimeo') {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
      }
    };

    const startMediaPlayback = (media, soundEnabled = false) => {
      if (media instanceof HTMLVideoElement) {
        media.muted = !soundEnabled;
        media.defaultMuted = !soundEnabled;
        media.playsInline = true;
        media.preload = 'auto';
        media.volume = soundEnabled ? 1 : 0;

        if (soundEnabled) {
          media.removeAttribute('muted');
        } else {
          media.setAttribute('muted', '');
        }

        if (media.readyState === 0) {
          media.load();
        }

        media.play().catch(() => {});

        return;
      }

      if (media instanceof HTMLIFrameElement) {
        startIframePlayback(media);
      }
    };

    const startHeroPlayback = (hero) => {
      const activeMedia = getActiveMedia(hero);
      const shouldEnableSound = hero.dataset.soundEnabled === 'true';

      if (activeMedia) {
        startMediaPlayback(activeMedia, shouldEnableSound);
      }
    };

    const syncHeroSound = (hero) => {
      const shouldEnableSound = hero.dataset.soundEnabled === 'true';
      const activeMedia = getActiveMedia(hero);

      hero.querySelectorAll(videoSelector).forEach((media) => {
        setMediaSound(media, shouldEnableSound && media === activeMedia);
      });
    };

    const setToggleState = (toggle, enabled) => {
      toggle.classList.toggle('is-sound-on', enabled);
      toggle.setAttribute('aria-pressed', `${enabled}`);
      toggle.setAttribute('aria-label', enabled ? toggle.dataset.unmutedLabel : toggle.dataset.mutedLabel);
    };

    const initHero = (hero) => {
      const toggle = hero.querySelector(toggleSelector);

      if (hero.dataset.initialized === 'true') return;

      hero.dataset.initialized = 'true';
      hero.dataset.soundEnabled = 'false';
      syncHeroSound(hero);
      startHeroPlayback(hero);

      hero.querySelectorAll('iframe[data-mlf-hero-video]').forEach((iframe) => {
        iframe.addEventListener('load', () => startHeroPlayback(hero), { once: true });
      });

      if (!toggle) return;

      setToggleState(toggle, false);

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const nextSoundState = hero.dataset.soundEnabled !== 'true';
        hero.dataset.soundEnabled = `${nextSoundState}`;
        setToggleState(toggle, nextSoundState);
        syncHeroSound(hero);
      });
    };

    const initHeroes = (root = document) => {
      if (root.matches?.(heroSelector)) {
        initHero(root);
      }

      root.querySelectorAll(heroSelector).forEach(initHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHeroes(), { once: true });
    } else {
      initHeroes();
    }

    document.addEventListener('shopify:section:load', (event) => initHeroes(event.target));

    window.addEventListener('resize', () => {
      document.querySelectorAll(heroSelector).forEach((hero) => {
        syncHeroSound(hero);
        startHeroPlayback(hero);
      });
    });

    window.addEventListener('pageshow', () => {
      document.querySelectorAll(heroSelector).forEach(startHeroPlayback);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
